module.exports = __webpack_public_path__ + "img/banner-mobile.e726f261.jpg";